import {AutoComplete} from "rsuite";
import {ESP_TYPE_OPTIONS} from "../Firmwares.model";
import "./EspTypePicker.scss";

type EspTypePickerProps = {
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
  models?: string[];
};

const EspTypePicker = ({value, onChange, disabled, models = []}: EspTypePickerProps) => (
  <label className="esp-type-picker">
    <span>Тип ESP</span>
    <AutoComplete
      aria-label="Тип ESP"
      placeholder="Выберите или введите модель ESP"
      data={Array.from(new Set([...ESP_TYPE_OPTIONS.map((option) => option.value), ...models, ...(value ? [value] : [])]))}
      value={value || ""}
      onChange={onChange}
      disabled={disabled}
    />
  </label>
);

export default EspTypePicker;
